
    import { ModalBeforeOpenEvent } from '@/models/Interfaces';
    import SelectOption from '@/models/SelectOption';
    import { PageModel, SMSsHistoryFilter } from '@/models/SMS';
    import _ from 'lodash';
    import { Options, Vue } from 'vue-class-component';
    import Carousel from '@/components/Modals/SMSModals/Carousel.vue';
    import Swal from 'sweetalert2';

    export type OnSaveCallback = (filter: SMSsHistoryFilter) => void;

    @Options<FilterModal>({
        props: {
            name: String,
        },
        components: {
            Carousel,
        },
    })
    export default class FilterModal extends Vue {
        private readonly name!: string;
        public SmsTemplates!: SelectOption[];
        public filter: SMSsHistoryFilter = new SMSsHistoryFilter();
        public templateId: string = '';
        public onSave: OnSaveCallback | null = null;
        public selectedPage: PageModel | null = null;
        public async beforeOpen(event: ModalBeforeOpenEvent) {
            this.filter = event.params.incomeFilter ? event.params.incomeFilter : new SMSsHistoryFilter();
            if (this.SmsTemplates && this.filter.Keywords) {
                this.selectedPage = null;
                const foundId = this.SmsTemplates.find((x) => x.text === this.filter.Keywords)?.id.toString();
                if (foundId) {
                    this.templateId = foundId;
                } else {
                    this.templateId = '';
                }
            }
            this.onSave = event.params?.onSave || null;
        }
        public modalSearch() {
            if (!this.selectedPage) {
                Swal.fire({
                    icon: 'error',
                    text: this.$t('page.automation.filter.selectLink') as string,
                });
                return;
            }
            this.$emit('selectPageLink', this.selectedPage.Link);
            this.$emit('selectPage', this.selectedPage);
        }
        public pageSelected(page: PageModel) {
            this.selectedPage = page;
        }
        // public saveSelectedTemplate() {
        //     this.$emit('templateSelected', this.selectedRow);
        // }
    }
